export default __webpack_public_path__ + "static/media/688.c73532fb.png";